<template>
  <PageTable :changeOrderCode="changeOrderCode" :disabled="disabled" />
</template>
<script>
import PageTable from './components/table'
export default {
  components: { PageTable },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
